/** Harita etiket düzeni (SVG viewBox birimi). Kalıcılık MongoDB /api/map-labels üzerinden. */

/**
 * Kayıtlı etiket düzeni (konum + isteğe bağlı ölçek / dönüş).
 * @typedef {Object} LabelOverride
 * @property {number} x
 * @property {number} y
 * @property {number} [scale] — 1 = varsayılan punto
 * @property {number} [rotate] — derece
 */

/** @type {{ provinces: Record<string, LabelOverride>, districts: Record<string, LabelOverride>, districtGlobalFontScale: number }} */
export const EMPTY_MAP_LABEL_STATE = {
  provinces: {},
  districts: {},
  districtGlobalFontScale: 1,
};

/**
 * Tüm ilçe etiketlerine uygulanan genel yazı çarpanı (tekil etiket `scale` ile çarpılır).
 * @param {unknown} v
 * @returns {number}
 */
export function normalizeDistrictGlobalFontScale(v) {
  if (typeof v !== 'number' || !Number.isFinite(v) || v <= 0) return 1;
  return Math.min(4, Math.max(0.25, v));
}

/**
 * @param {unknown} v
 * @returns {LabelOverride | null}
 */
export function normalizeLabelOverride(v) {
  if (!v || typeof v !== 'object' || Array.isArray(v)) return null;
  if (typeof v.x !== 'number' || typeof v.y !== 'number' || !Number.isFinite(v.x) || !Number.isFinite(v.y)) {
    return null;
  }
  let scale = typeof v.scale === 'number' && Number.isFinite(v.scale) && v.scale > 0 ? v.scale : 1;
  scale = Math.min(4, Math.max(0.25, scale));
  const rotate = typeof v.rotate === 'number' && Number.isFinite(v.rotate) ? v.rotate : 0;
  return { x: v.x, y: v.y, scale, rotate };
}

/**
 * @param {unknown} raw
 * @returns {Record<string, LabelOverride>}
 */
export function normalizeOverrideMap(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  /** @type {Record<string, LabelOverride>} */
  const out = {};
  Object.entries(raw).forEach(([k, v]) => {
    const n = normalizeLabelOverride(v);
    if (n) out[k] = n;
  });
  return out;
}

/**
 * @param {unknown} raw
 * @returns {{
 *   provinces: Record<string, LabelOverride>,
 *   districts: Record<string, LabelOverride>,
 *   districtGlobalFontScale: number
 * }}
 */
export function normalizeMapLabelState(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...EMPTY_MAP_LABEL_STATE, provinces: {}, districts: {} };
  }
  return {
    provinces: normalizeOverrideMap(raw.provinces),
    districts: normalizeOverrideMap(raw.districts),
    districtGlobalFontScale: normalizeDistrictGlobalFontScale(raw.districtGlobalFontScale ?? 1),
  };
}
